<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [style]="{width: '460px'}"
    [dismissableMask]="true"
    (onHide)="close()"
>
    <ng-template #header>
        <span
            class="fs-6 fw-bold"
            i18n="@@tileIconPickerHeader"
        >Icon auswählen</span>
    </ng-template>

    <input
        type="text"
        class="form-control"
        [(ngModel)]="search"
        (ngModelChange)="onSearchChange()"
        placeholder="Icon suchen…"
        i18n-placeholder="@@tileIconPickerSearchPlaceholder"
    >

    <div class="tile-icon-picker-grid">
        <button
            type="button"
            class="tile-icon-picker-item"
            *ngFor="let name of filteredIcons"
            [title]="name"
            (click)="select(name)"
        >
            <span
                class="tile-icon-picker-badge"
                [ngStyle]="{'background-color': color}"
            >
                <i
                    class="ri-{{name}}"
                    [ngStyle]="{color: iconColor}"
                ></i>
            </span>
        </button>
        <p
            class="tile-icon-picker-empty"
            *ngIf="filteredIcons.length === 0"
            i18n="@@tileIconPickerNoResults"
        >Keine Icons gefunden.</p>
    </div>
</p-dialog>
